import { palette } from '../../../styles/variables'
import { translate } from '../../../utils/translation'
import successTick from '../../../styles/assets/checkoutModal/success-tick.png'
import { Text } from '../../../components/topography'
import Modal from '../../../components/modal/Modal'
import Icon from '../../../components/icon/Icon'
import { CloseButton } from '../../../components/buttons/Buttons'

export default ({ addonTitle, isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      desktopStyle={{
        width: '95%',
        maxWidth: '512px',
        height: 'fit-content',
        minHeight: '360px',
        overflow: 'unset',
        overflowY: 'auto',
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        inset: 'auto',
        padding: '0px',
      }}
      mobileStyle={{
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
      }}
      overlayStyle={{
        zIndex: 99999,
      }}
    >
      <div
        style={{
          padding: '40px',
          borderBottom: `1px solid ${palette.lightGray50}`,
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        <CloseButton
          onClick={onClose}
          styles={{
            position: 'absolute',
            top: 20,
            right: 20,
          }}
        />
        <Icon src={successTick} size="64px" />
        <Text
          fontSize="22px"
          lineHeight="38.4px"
          textAlign="center"
          margin="24px 0 0 0"
          dangerouslySetInnerHTML={{
            __html: translate('addon_confirmation_heading', addonTitle),
          }}
        />
        <div
          style={{
            width: '56px',
            borderBottom: `1px solid ${palette.orange}`,
            marginTop: '24px',
          }}
        />
        <Text
          margin="40px 0 0 0"
          fontSize="14px"
          lineHeight="26px"
          textAlign="center"
        >
          {translate('addon_confirmation_subheading')}
        </Text>
      </div>
    </Modal>
  )
}
